export const SPECIALTY_BOARD_ROUTE_NAME = 'specialtyBoards';

export const SPECIALTY_BOARD_ROUTES = {
  get: '/medical-specialty-boards/{medicalBoardId}',
};
